var _path, _path2, _path3, _path4, _ellipse, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciseLocationSelectedFocused({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 56,
    viewBox: "0 0 31 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6694 41C29.6694 49.008 23.1756 55.5 15.1648 55.5C7.15395 55.5 0.660156 49.008 0.660156 41C0.660156 32.992 7.15395 26.5 15.1648 26.5C23.1756 26.5 29.6694 32.992 29.6694 41Z",
    fill: "#EE4360",
    fillOpacity: 0.3,
    stroke: "#FFA4B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1437 14.6939C29.1437 11.0621 27.6704 7.57897 25.048 5.01087C22.4256 2.44276 18.8688 1 15.1602 1V7.31812C16.1492 7.31811 17.1287 7.50889 18.0424 7.87956C18.9562 8.25023 19.7865 8.79352 20.4859 9.47843C21.1853 10.1633 21.7401 10.9764 22.1186 11.8713C22.4971 12.7662 22.6919 13.7253 22.6919 14.6939C22.6919 15.6625 22.4971 16.6216 22.1186 17.5165C21.7401 18.4114 21.1853 19.2245 20.4859 19.9094C19.7865 20.5943 18.9562 21.1376 18.0424 21.5083C17.1287 21.8789 16.1492 22.0698 15.1602 22.0698V40.9866C15.1602 40.9866 21.7553 30.6905 24.2499 27.171C29.7554 19.4489 29.1437 14.6939 29.1437 14.6939Z",
    fill: "#EE4360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1655 7.31812V1C11.4568 1 7.90004 2.44276 5.27763 5.01087C2.65521 7.57897 1.18196 11.0621 1.18196 14.6939C1.18196 14.6939 0.551121 19.4489 6.07571 27.171C8.57037 30.653 15.1655 40.9866 15.1655 40.9866V22.0698C13.1679 22.0698 11.2522 21.2926 9.83969 19.9094C8.42721 18.5262 7.63368 16.6501 7.63368 14.6939C7.63368 12.7377 8.42721 10.8617 9.83969 9.47846C11.2522 8.09522 13.1679 7.31812 15.1655 7.31812Z",
    fill: "#EE4360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1688 14.7143C29.1688 20.2 19.8326 34.5238 15.1645 41C10.626 34.3968 1.15994 20.4286 1.16016 14.7143C1.1604 8.2269 6.21727 1 15.1645 1C24.1117 1 29.1688 7.85714 29.1688 14.7143Z",
    stroke: "#EE4360",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1631,
    cy: 14.7081,
    rx: 12.4483,
    ry: 12.1905,
    fill: "#EE4360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4222 15.5586C13.4222 15.5586 13.4829 19.9844 10.0877 20.1801C6.69305 20.3744 4.57031 16.7953 4.57031 16.7953C4.57031 16.7953 12.998 15.8848 13.4222 15.5586Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9421 11C24.9421 11 16.9398 11.3907 13.423 11C13.423 11 16.2124 18.6142 10.9375 20.826C10.9375 20.826 14.0903 21.2174 16.8189 20.826C19.5469 20.4353 25.61 18.9397 24.9421 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciseLocationSelectedFocused);
export default __webpack_public_path__ + "static/media/precise-location-selected-focused.5e551a08b6e52e26a15aeffaf17b5c3d.svg";
export { ForwardRef as ReactComponent };